import { Typography } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import BoldText from 'components/BoldText';
import useStyles from 'features/Events/components/EventsChart/EventsModal/EventsModalDetail/EventsModalDetail.styles';

type EventsModalDetailProps = {
  label: string;
  value: string;
  textSeparator: boolean;
};

const EventsModalDetail = ({ label, value, textSeparator }: EventsModalDetailProps) => {
  const classes = useStyles();

  return (
    <>
      {textSeparator && <span data-testid={'text-separator'} className={classes.textSeparator} />}
      <Typography className={classes.details}>
        {label} <BoldText text={value} />
      </Typography>
    </>
  );
};

export default EventsModalDetail;
